export default {"src":"/_next/static/media/AppStore.7c197023.svg","height":50,"width":167,"blurWidth":0,"blurHeight":0};